export const PUBLIC_POSTHOG_KEY =
  'phc_SibW4eaQe9gWfoE8oDRw3g63SZg1Nvgbfmh3LMX44D9';
export const PUBLIC_POSTHOG_HOST = 'https://us.i.posthog.com';
